module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"apply":"Apply Here"},"zh":{"apply":"在这里申请"}}')
  delete Component.options._Ctor
}
